import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import './global-styles.css';
import MyNavbar from './components/MyNavbar.js';
import Connect from './components/Connect.js';
import FooterHelp from './components/FooterHelp.js';
import FooterBottom from './components/FooterBottom.js';
import { withRouter } from 'react-router'
import ShopItemAddedPopup from './components/ShopItemAddedPopup.js';

class App extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    cartItemCount: PropTypes.number.isRequired,
    cartPriceTotal: PropTypes.number.isRequired,
    user: PropTypes.object,
    userLoggedIn: PropTypes.bool.isRequired,
    setCartItemCount: PropTypes.func.isRequired,
    setCartPriceTotal: PropTypes.func.isRequired,
    setUser: PropTypes.func.isRequired,
    setUserLoggedIn: PropTypes.func.isRequired,
    logoutClick: PropTypes.func.isRequired,
    loginClick: PropTypes.func.isRequired,
    loggedInEmailClick: PropTypes.func.isRequired,
    setDefaultCartStateValues: PropTypes.func.isRequired,
    setCurrentRoute: PropTypes.func.isRequired,
    setPreviousRoute: PropTypes.func.isRequired,
    scrollToSection: PropTypes.func.isRequired,
    homeIsMounted: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {

    };
  }
  
  componentDidMount() {
    this.props.history.listen((location, action) => {
      this.props.setPreviousRoute(this.props.location);
      this.props.setCurrentRoute(location);
      setTimeout(() => { this.handleRouteChangeStuff(); }, 0) })
  }

  handleRouteChangeStuff = () => {
      //console.log(this.props.previousRoute);
      //console.log(this.props.currentRoute);

      // Scrolls to top on every route change unless you are leaving cart.
      this.tryScrollToTopOnRouteChange();

      // When you exit from cart, return to proper page, unless it is from returning from paypal confirmation.
      this.fixCartPathname();
      
      // If a scroll to section is clicked on while you're on home page, just scroll to it.
      this.tryScrollToSectionFromSamePage();

      // If a scroll to section is clicked on while you're on another page: wait for timeout to load page, then scroll to it.
      this.tryScrollToSectionFromOtherPage();


      //if(this.state.currentRoute)
      /*
      if ( (this.props.location.hash.length < prevProps.location.hash.length) 
        && ! this.props.location.hash.toUpperCase().includes("CONFIRM") && !prevProps.location.hash.toUpperCase().includes("CONFIRM") ) {

        var location = this.props.location;
        location.hash = "";
      */

        //this.props.history.push({ pathname: "/empty" }); maybe need to reimplement for some reason payment wise?
        /*
        setTimeout(() => {
          this.props.history.replace({pathname: location.pathname})
        });
        */
  }

  tryScrollToTopOnRouteChange = () => {
    // Scrolls to top on every route change unless you are leaving cart.
    try {
      if ( ( (this.props.currentRoute.pathname !== this.props.previousRoute.pathname) 
              || (this.props.currentRoute.pathname == "/" && this.props.previousRoute.pathname == "/") )
        && !this.props.previousRoute.hash.toUpperCase().includes("CART") && this.props.currentRoute.pathname !== "/aboutUs" 
        && this.props.currentRoute.pathname !== "/aboutOurCandles"  ) {
        window.scrollTo(0, 0);
      }
    }
    catch(err) {
      console.log("Error in App.js: " + err);
    }

  }

  fixCartPathname = () => {
    // When you exit from cart, return to proper page, unless it is from returning from paypal confirmation.
      if(this.props.currentRoute.hash == "#!/") {
        // Set current hash to empty.
        this.props.history.replace({pathname: this.props.location.pathname})
      }
  }

  tryScrollToSectionFromSamePage = () => {
     // If a scroll to section is clicked on while you're on home page, just scroll to it.
      if(this.props.previousRoute.pathname == "/" || this.props.previousRoute.pathname == "/aboutUs" || this.props.previousRoute.pathname == "/aboutOurCandles" ) {
          if(this.props.currentRoute.pathname == "/aboutUs") {
              this.props.scrollToSection("AboutUsSectionID", -115);
          }
          if(this.props.currentRoute.pathname == "/aboutOurCandles") {
              this.props.scrollToSection("AboutOurCandlesSectionID", -115);
          }
      }
  }

  tryScrollToSectionFromOtherPage = () => {
      // If a scroll to section is clicked on while you're on another page: wait for timeout to load page, then scroll to it.
      if( (this.props.previousRoute.pathname != "/" && this.props.previousRoute.pathname != "/aboutUs" && this.props.previousRoute.pathname != "/aboutOurCandles")
          && (this.props.currentRoute.pathname == "/aboutUs" || this.props.currentRoute.pathname == "/aboutOurCandles") )
      {
        setTimeout(() => {
          if(this.props.currentRoute.pathname == "/aboutUs") {
              this.props.scrollToSection("AboutUsSectionID", -115);
          }
          if(this.props.currentRoute.pathname == "/aboutOurCandles") {
              this.props.scrollToSection("AboutOurCandlesSectionID", -115);
          }

        }, 1000)
      }
  }

  render() {
    //const ExampleObject = ( <div></div> );

    return (
      <div>
        {/*ExampleObject*/}
        <Helmet>
        <title>Primitive's Candles: Handpoured Rustic Candles </title>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="description" content="Shop Primitive's Candles! Our candle products maintain full scent as they burn. 
          Handpoured with care in Galeton, PA with strong, aromatic fragrances." />
        <meta name="robots" content="index,follow,imageindex,noodp" />
        <link rel="canonical" href="https://www.primitivescandles.com" />
        <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0-alpha.6/css/bootstrap.min.css" integrity="sha384-rwoIResjU2yc3z8GV/NPeZWAv56rSmLldC3R/AZzGRnGxQQKnKkoFVhFQhNUwEyJ" crossorigin="anonymous" />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Handlee" /> 
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Raleway" /> 
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Old+Standard+TT" /> 
        <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" />
          {/*<link href="https://cdn.snipcart.com/themes/2.0/base/snipcart.min.css" type="text/css" rel="stylesheet" />*/}
          
        </Helmet>

        {this.props.location.pathname !== "/404" ? <MyNavbar {...this.props} /> : ""}

        {this.props.children } 

        {this.props.location.pathname !== "/404" ?    
          <div>  
            <Connect />
            <FooterHelp scrollToSection={this.props.scrollToSection} aboutUsClick={this.props.aboutUsClick}/>
            <FooterBottom />
          </div> : ""}

        {this.props.homeIsMounted || this.props.shopIsMounted ? 
        <ShopItemAddedPopup itemAddedPopupName={this.props.itemAddedPopupName} itemAddedPopupQuantity={this.props.itemAddedPopupQuantity}
                            itemAddedPopupImage={this.props.itemAddedPopupImage} itemAddedPopupOpen={this.props.itemAddedPopupOpen}
                            onAfterOpen={this.props.onAfterOpen} itemAddedPopupClosing={this.props.itemAddedPopupClosing} />
         : ""}

      </div>
    );
  }
}

export default withRouter(App);


// WEBPACK FOOTER //
// ./src/App.js